import {
  AutocompleteArrayInput,
  BooleanInput,
  ReferenceArrayInput,
} from "react-admin";
import React, { useEffect, useState } from "react";
import { useField } from "react-final-form";

const DriversInput = () => {
  const notificationTargetTypeField = useField("notificationTargetType");
  const routeInput = useField("routeId");
  const schoolInput = useField("schoolId");
  const busScheduleInput = useField("busScheduleId");

  const isSendToAllField = useField("isSendToAllDrivers");
  const driverIdsField = useField("driverIds");
  const [isDisabled, setIsDisabled] = useState<boolean>(false);

  useEffect(() => {
    if (isSendToAllField.input.value) {
      setIsDisabled(true);
      driverIdsField.input.onChange([]);
    }
  }, [isSendToAllField.input.value]);

  const filter = (targetType: string) => {
    let filter;
    switch (targetType) {
      case "school":
        filter = { ActiveAssignmentSchoolId: Number(schoolInput.input.value) };
        break;
      case "bus_schedule":
        filter = {
          ActiveAssignmentBusScheduleId: Number(busScheduleInput.input.value),
        };
        break;
      case "route":
        filter = { ActiveAssignmentRouteId: Number(routeInput.input.value) };
        break;
    }

    return filter;
  };

  return (
    <>
      <ReferenceArrayInput
        label="Driver"
        source="driverIds"
        reference="drivers"
        filter={filter(notificationTargetTypeField.input.value)}
        filterToQuery={(searchText: string) => {
          if (searchText !== "") return { search: searchText };
        }}
        disabled={isDisabled}
      >
        <AutocompleteArrayInput optionText="fullName" />
      </ReferenceArrayInput>
      <BooleanInput label="Send To All Drivers" source="isSendToAllDrivers" />
    </>
  );
};

export default DriversInput;
